<template>
     <div class="main-business-content">
            <h3 class="main-business-title">
                {{details.title}}
            </h3>
            <div class="addtime">{{details.addtime}}</div>
            <div class="business-info" v-html="details.content"></div>

       </div>
</template>

<script>
export default {
    data(){
        return {
          details:''  
        }
    },
    methods:{
        getMass: function(){
            var that = this;
            that.$http.post(that.baseUrl+that.config.MassInfo+'?business_id='+that.businessId).then(function(ev){
                console.log(ev);
                if(ev.data.code == 100){
                    that.details = ev.data.data;
                    console.log(that.details);
                }
            }).catch(function(error){
                console.log(error)
            })
        }
    },
    mounted(){
        this.baseUrl = window.baseUrl;
        this.config = window.config;
        this.businessId = this.$route.params.business_id;
        this.getMass();
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/businessDetail.vue